import triniImg from "../assets/img/trini-talk-bot-big.svg";

const LoadingGlobal = () => {
  return (
    <div className="d-flex justify-content-center align-items-center">
      <img
        src={triniImg}
        alt=""
        width={"30%"}
        style={{ position: "absolute", top: "30%", minWidth: "250px" }}
      />
    </div>
  );
};

export default LoadingGlobal;
